import React, { useState, useEffect } from 'react'
import axios from 'axios'

const Mensagem = () => {
    const [mensagem, setMensagem] = useState({userFonte: '', data: '', texto: ''})
    const dados = {idUser: localStorage.idE, idMensagem: window.location.pathname.slice(16)}

    useEffect(() => {
        const url = `/api/mensagem/getIdMensagem`
        axios.post(url, dados)
            .then(res => {
                setMensagem(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const arquivar = () => {
        const url = '/api/mensagem/arquivarEtica/'
        axios.post(url, dados)
            .then(res => {
                alert(res.data)
                window.location = '/etica/minhasMensagens'
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-envelope iconeBuscaPed"></i>
                MENSAGEM
            </div>
            <div className="caixaMensagemEnvio">
                <div className="labelSuporte"></div>
                <label className="destinatarioEnvio">Usuário</label>
                <label className="destinatarioMensagem">{mensagem.usuarioFonte}</label>
                <label className="destinatarioEnvio">Data</label>
                <label className="destinatarioMensagem">{mensagem.data}</label>
                <span className='destinatarioEnvio'>Mensagem</span>
                <textarea className='textareaMensagemEnvio' value={mensagem.texto}></textarea>
            </div>
            <button className="botaoNPed" onClick={() => arquivar()}>ARQUIVAR</button>
        </React.Fragment>
    )
}

export default Mensagem